import * as React from 'react';
import LoadingDisplay from './LoadingDisplay';

require('../css/text-input.css');

interface Props {
  id: string;
  value: string;
  label: string;

  // Adding a property to add external css class. 
  inputClassName?: string;
  labelClassName?: string;
  iconClassName?: string;
  divClassName?: string;

  placeholder?: string;
  icon?: string;
  dataValidMessage?: string;
  dataInvalidMessage?: string;
  forceHighlightErrors?: boolean;
  processing?: boolean;

  divClasses?: string;

  showUppercase?: boolean;
  validateRegex?: RegExp;
  paymentErrorMsg?: string;
  isNumberOnly?: boolean;

  wrapperProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
  iconProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  >;
  inputProps?: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
  labelProps?: React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >;
  validator?(value: string): boolean;
  onChange(value: string): void;
  onChangeImmediate?(value: string): void;
  onBlur?(value: string): void;
  regexValidator?(value: string, regex: RegExp): boolean;
  handlePostcodeLookup?(): void;
}

interface State {
  active: boolean;
  wasFocussed: boolean;
  buffer: string;
  paymentError: boolean;
}

class TextInput extends React.Component<Props, State> {
  private inputRef: React.RefObject<HTMLInputElement>;

  constructor(props: Props) {
    super(props);

    this.state = {
      active: false,
      wasFocussed: false,
      buffer: props.value,
      paymentError: true,
    };

    this.inputRef = React.createRef<HTMLInputElement>();
  }

  componentDidUpdate() {
    if (this.inputRef.current) {
      this.inputRef.current.value = this.state.buffer;
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.value !== this.state.buffer) {
      this.setState({ buffer: nextProps.value });
    }
  }

  handleFocus = () => {
    this.setState({ ...this.state, active: true });
  };

  handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    this.setState({ ...this.state, active: false, wasFocussed: true });
    
    if (this.props.onBlur) {
      this.props.onBlur(this.state.buffer);
    }
    
    this.props.onChange(this.state.buffer);
    if (this.props.showUppercase) {
      this.setState(prevState => ({buffer: prevState.buffer.toUpperCase()}));
    }
    if (this.props.handlePostcodeLookup) {
      this.props.handlePostcodeLookup();
    }
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const buffer = e.target.value;
    var isNumber = true;

    if (this.props.isNumberOnly !== undefined && this.props.isNumberOnly) {
      if (buffer !== '' ) {
        let validMoneyRegExp = /^(?=.*\d)(?:\d+\.?\d*|\.\d+)$/;
        isNumber = validMoneyRegExp.test(buffer);
      }
    }
    
    if (isNumber) {
      this.setState(() => ({ buffer }));
      this.setState({paymentError: false});
      if (this.props.onChangeImmediate) {
        this.props.onChangeImmediate(buffer);
      }
    }
  };
 
  renderIcon() {
    if (!this.props.icon) {
      return;
    }
    // Check if external css properties comes from parent
    let iconUserClass = this.props.iconClassName === null ? '' : this.props.iconClassName;

    return (
      <i className={`material-icons ${iconUserClass}`} {...this.props.iconProps}>
        {this.props.icon}
      </i>
    );
  }

  render() {
    let p = this.props;
    let active = this.state.active || p.value.length;
    let labelClass = active ? 'active' : '';
    let validClass = '';
    let inputClass = '';

    if (
      p.validator &&
      (this.state.wasFocussed || this.props.forceHighlightErrors)
    ) {
      inputClass = p.validator(p.value) ? 'valid' : 'invalid';
      validClass = 'validate';
    }

    if (p.paymentErrorMsg !== undefined) {
      inputClass = this.state.paymentError ? 'invalid' : 'valid';
    }

    if (p.regexValidator && p.validateRegex && p.value !== '') {
      inputClass = p.regexValidator(p.value, p.validateRegex) ? 'valid' : 'invalid';
      validClass = 'validate';
    }

    if (this.state.active) {
      inputClass = '';
    }

    if (this.props.processing) {
      inputClass += ' processing';
    }

    // Check if external css properties comes from parent
    let inputUserClass = this.props.inputClassName === null ? '' : this.props.inputClassName;
    let labelUserClass = this.props.labelClassName === null ? '' : this.props.labelClassName;
    let divUserClass = this.props.divClassName === null ? '' : this.props.divClassName;
    
    return (
      <div className={`input-field ${this.props.divClasses} ${divUserClass}`} id={`${this.props.id}-input-field`}>
        {this.renderIcon()}
        <input
          id={p.id}
          value={this.state.buffer}
          className={`${validClass} ${inputClass} ${inputUserClass} textInputClass`}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          disabled={this.props.processing}
          placeholder={this.props.placeholder}
          ref={this.inputRef}
          {...p.inputProps}
        />
        {this.props.processing && (
          <span
            style={{
              height: '20px',
              width: '20px',
              display: 'inline-block',
              position: 'absolute',
              right: '10px',
              top: '15px'
            }}
          >
            <LoadingDisplay loadingMessage="" />
          </span>
        )}
        <label
          htmlFor={p.id}
          className={`${labelClass} ${labelUserClass} TextInputLabelClass`}
          data-error={p.dataInvalidMessage}
          data-success={p.dataValidMessage}
          {...p.labelProps}
        >
          {p.label}
        </label>
      </div>
    );
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/Components/TextInput.tsx